import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
const TabList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const tabLabel = useFormInput("");
  const [tabId, setTabId] = useState("");
  const [tabElem, setTabElem] = useState("");
  const [tabType, setTabType] = useState("");
  const [options, setOptions] = useState(props.options);

  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const checkValueExist = (value) => {
    return characters.some(function (el) {
      return el.value === value;
    });
  };
  const newContainer = (event) => {
    event.preventDefault();

    const newer = {
      value: tabId,
      label: tabLabel.value,
      order: characters.length + 1,
      id: tabId,
      elem: tabElem,
      type: tabType,
      draft: true,
      publish: false,
    };
    if (characters.length < 3 && !checkValueExist(newer.value)) {
      updateCharacters([...characters, newer]);
      const newArray = [...characters, newer];
      props.onChange(newArray);
    } else {
      toastr.error("Limit Reached or Element Already Exist", "Error");
    }
  };

  const onChangePage = (value, evt) => {
    setTabId(value.value);
    setTabElem(value.label);
    setTabType(value.type);
  };

  useEffect(() => {
    setOptions([...props.data]);
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label:
          props.list.length > 0
            ? findObject(props.list, item.itemid) === ""
              ? item.itemRef
              : findObject(props.list, item.itemid)
            : item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
        type: item.itemType,
        draft:
          props.list.length > 0
            ? findObjectStatus(props.list, item.itemid)
            : true,
        publish:
          props.list.length > 0
            ? findObjectPublish(props.list, item.itemid)
            : false,
      }));

      updateCharacters(opt);
    };
    const findObject = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.referenceName;
      } else {
        return "";
      }
    };

    const findObjectStatus = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.draftStatus;
      } else {
        return false;
      }
    };
    const findObjectPublish = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.publishStatus;
      } else {
        return false;
      }
    };
    getDetails();
  }, [props.listData, props.data, props.list]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      <div className="col-sm-12">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
            <div className="col-md-5">
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Tab Name
              </label>
              <input
                type="text"
                dir={props.dir}
                name="tabName"
                className="form-control inside-form"
                placeholder="Tab Name ..."
                {...tabLabel}
                autoComplete="off"
              />
            </div>
            <div className="col-md-5" dir={props.dir}>
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                Tab Container
              </label>
              <Select
                name="tabId"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={options}
                onChange={(value, event) => onChangePage(value, event)}
              ></Select>
            </div>
            {!(props.dir === "rtl") && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <ul
                className="products-list product-list-in-card pl-2 pr-2"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                {characters.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={"item" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <li
                        className="item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="product-info">
                          <a
                            href={"/item/" + item.type + "/" + item.id}
                            className="product-title"
                          >
                            {item.label}
                            <span className="badge badge-warning float-left">
                              {item.order}
                            </span>
                          </a>

                          <div
                            className="text-right"
                            style={{ display: "inline", float: "right" }}
                          >
                            <label
                              className={
                                item.draft && item.publish
                                  ? "badge badge-success"
                                  : "badge badge-danger"
                              }
                            >
                              {item.draft && item.publish
                                ? "Published"
                                : "Draft"}
                            </label>
                            <a
                              className="btn btn-light btn-sm"
                              href="#!"
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                          <span
                            className="product-description"
                            style={{ marginLeft: "55px" }}
                          >
                            {item.elem}
                          </span>
                        </div>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default TabList;
